// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import Cookies from 'js-cookie'

// Internal Dependencies:
import Text from 'components/Form/Text'
import Link from 'components/Link/Link'

// Redux:
import { getPageData } from 'actions/page'

class _PasswordProtected extends React.Component {
	constructor() {
		super()

		this.state = {
			pagePassword: '',
			pagePasswordError: false
		}
	}

	handleChange = ( id, value ) => {
		this.setState( {
			[ id ]: value
		} )
	}

	handleSubmitPagePassword = ( e ) => {
		e.preventDefault()
		const form = e.currentTarget
		const { dispatch, page, sitewide } = this.props
		const { pagePassword } = this.state
		let cookieId = ''

		if ( ! sitewide && ! page ) {
			return
		}

		if ( sitewide ) {
			cookieId = 'site_password'
		} else {
			cookieId = `${page.content_type}_password_${page.slug}`
		}

		Cookies.set( cookieId, pagePassword )

		window.dispatchEvent(
			new CustomEvent( 'doPageTransitionLeftToRight' )
		)

		document.documentElement.classList.add( 'has-transition-page-leaving' )

		setTimeout( () => {
			document.documentElement.classList.remove( 'has-transition-page-leaving' )

			if ( sitewide ) {
				location.reload()
			} else {
				dispatch(
					getPageData( {
						type: page.content_type,
						slug: page.slug,
						force: true
					} )
				)
			}
		}, 400 )
	}

	render() {
		const { pagePassword } = this.state

		return (
			<div className="page-password-protected">
				<div className="-inner">
					<div className="-content">
						<h2>Get Access</h2>
						<p>Enter your password or request access <Link to="/contact">here</Link></p>

						<form className="form" action="" onSubmit={ this.handleSubmitPagePassword }>
							<Text
								id="pagePassword"
								label="Password"
								onChange={ this.handleChange }
								type="password"
								uncontrolled={ true }
							/>

							<div className="form-item">
								<button className="button -plain" type="submit">Welcome!</button>
							</div>
						</form>
					</div>

					<div className="-image-wrap">
						<div className="-inner">
							<div className="-image">
								<img src={ `${siteData.images_url}bg/home-slider/mountains.png` } alt="" />
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	const page = ownProps.pageOverride ? ownProps.pageOverride : state.page.selected

	return {
		page
	}
}

export default connect( mapStateToProps )( _PasswordProtected )



// WEBPACK FOOTER //
// ./components/PageSections/_PasswordProtected.jsx